module.exports = __webpack_public_path__ + "img/icone_sensor_removido.5b66c57c.png";